export default class {
	idDocumentoPedido
	tipoRegistroDocumento
	situacao

	constructor(documento) {
		this.idDocumentoPedido = documento.id
		this.tipoRegistroDocumento = documento.tipoRegistroDocumento
		this.situacao = documento.situacao
	}
}
